type IconFamiliarFaceProps = {
    className?: string;
};

export function IconFamiliarFace(props: IconFamiliarFaceProps) {
    const { className = '' } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden={true}
            className={`${className}`}
        >
            <mask
                id="mask0_6947_18955"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_6947_18955)">
                <path
                    d="M12 20C9.76667 20 7.875 19.225 6.325 17.675C4.775 16.125 4 14.2333 4 12C4 9.76667 4.775 7.875 6.325 6.325C7.875 4.775 9.76667 4 12 4C14.2333 4 16.125 4.775 17.675 6.325C19.225 7.875 20 9.76667 20 12C20 14.2333 19.225 16.125 17.675 17.675C16.125 19.225 14.2333 20 12 20ZM12 18C13.6667 18 15.0833 17.4167 16.25 16.25C17.4167 15.0833 18 13.6667 18 12C18 11.7167 17.9792 11.4375 17.9375 11.1625C17.8958 10.8875 17.8333 10.6167 17.75 10.35C17.5 10.4 17.25 10.4375 17 10.4625C16.75 10.4875 16.5 10.5 16.25 10.5C15.2 10.5 14.2 10.3 13.25 9.9C12.3 9.5 11.45 8.91667 10.7 8.15C10.2333 9.1 9.59167 9.925 8.775 10.625C7.95833 11.325 7.03333 11.8333 6 12.15C6.05 13.7833 6.65417 15.1667 7.8125 16.3C8.97083 17.4333 10.3667 18 12 18ZM6.4 9.85C7.13333 9.46667 7.69167 9.02083 8.075 8.5125C8.45833 8.00417 8.83333 7.4 9.2 6.7C8.56667 7.03333 8.00833 7.47083 7.525 8.0125C7.04167 8.55417 6.66667 9.16667 6.4 9.85ZM8.7875 13.7125C8.59583 13.5208 8.5 13.2833 8.5 13C8.5 12.7167 8.59583 12.4792 8.7875 12.2875C8.97917 12.0958 9.21667 12 9.5 12C9.78333 12 10.0208 12.0958 10.2125 12.2875C10.4042 12.4792 10.5 12.7167 10.5 13C10.5 13.2833 10.4042 13.5208 10.2125 13.7125C10.0208 13.9042 9.78333 14 9.5 14C9.21667 14 8.97917 13.9042 8.7875 13.7125ZM16.25 8.5H16.55C16.65 8.5 16.75 8.49167 16.85 8.475C16.3 7.725 15.6042 7.125 14.7625 6.675C13.9208 6.225 13 6 12 6H11.7C11.6 6 11.5083 6.00833 11.425 6.025C12.075 6.775 12.7625 7.375 13.4875 7.825C14.2125 8.275 15.1333 8.5 16.25 8.5ZM13.7875 13.7125C13.5958 13.5208 13.5 13.2833 13.5 13C13.5 12.7167 13.5958 12.4792 13.7875 12.2875C13.9792 12.0958 14.2167 12 14.5 12C14.7833 12 15.0208 12.0958 15.2125 12.2875C15.4042 12.4792 15.5 12.7167 15.5 13C15.5 13.2833 15.4042 13.5208 15.2125 13.7125C15.0208 13.9042 14.7833 14 14.5 14C14.2167 14 13.9792 13.9042 13.7875 13.7125ZM1 6V3C1 2.45 1.19583 1.97917 1.5875 1.5875C1.97917 1.19583 2.45 1 3 1H6V3H3V6H1ZM6 23H3C2.45 23 1.97917 22.8042 1.5875 22.4125C1.19583 22.0208 1 21.55 1 21V18H3V21H6V23ZM18 23V21H21V18H23V21C23 21.55 22.8042 22.0208 22.4125 22.4125C22.0208 22.8042 21.55 23 21 23H18ZM21 6V3H18V1H21C21.55 1 22.0208 1.19583 22.4125 1.5875C22.8042 1.97917 23 2.45 23 3V6H21Z"
                    fill="black"
                />
            </g>
        </svg>
    );
}

export default IconFamiliarFace;
